<div
  class="card"
  (click)="preview(file)"
  [class.borderless]="borderless"
  [class.backgroundless]="backgroundless"
  [class.details]="view === 'details'"
  [class.details-large]="view === 'details-large'"
  [class.small]="view === 'small'"
  [class.medium]="view === 'medium'"
  [class.large]="view === 'large'"
  [class.clickable]="clickable"
  [class.error]="file?.status === 'error'"
>
  <div class="header">
    <div class="actions">
      <label
        style="transform: scale(1.5)"
        *ngIf="selectable"
        nz-checkbox
        [ngModel]="fileManagerService.isFileSelected(file.id)"
        (ngModelChange)="checkboxChanged(file)"
      >
      </label>

      <nz-icon
        *ngIf="view !== 'details' && view !== 'details-large'"
        nzType="info-circle"
        nzTheme="outline"
        nz-tooltip
        [nzTooltipTitle]="Tooltip"
      />
    </div>

    <div class="thumbnail">
      @if (file?.status === 'loading') {
        <nz-spin nzSimple></nz-spin>
      } @else {
        @if (file.extension === 'csv') {
          <img src="/assets/img/csv.png" class="w-12" />
        } @else if (file.extension === 'odt') {
          <img src="/assets/img/odt.png" class="w-12" />
        } @else if (file.extension === 'txt') {
          <img src="/assets/img/txt.png" class="w-12" />
        } @else if (file.extension === 'xlsx') {
          <img src="/assets/img/xlsx.png" class="w-12" />
        } @else if (file.extension === 'docx') {
          <img src="/assets/img/docx.png" class="w-12" />
        } @else if (file.extension === 'docx') {
          <img src="/assets/img/docx.png" class="w-12" />
        } @else if (file.extension === 'pdf') {
          <img src="/assets/img/pdf.png" class="w-12" />
        } @else if (file.filetype === 'video') {
          <img src="/assets/img/video.png" />
        } @else if (file.filetype === 'image' || file.filetype === 'picture') {
          @if (!file.url && !file.thumbnail) {
            <img src="/assets/img/img.png" class="w-12" alt="" />
          } @else if (file.url || file.thumbnail) {
            <div
              class="thumbnail-image"
              [style.background-image]="
                file.thumbnail
                  ? 'url(' + file.thumbnail + ')'
                  : 'url(' + file.url + ')'
              "
            ></div>
          }
        } @else {
          <img src="/assets/img/file.png" class="w-12" />
        }
      }
    </div>
  </div>

  <div
    class="footer"
    *ngIf="view === 'details' || view === 'details-large'"
    nz-tooltip
    [nzTooltipMouseEnterDelay]="1"
    [nzTooltipTitle]="Tooltip"
  >
    <ng-container *ngTemplateOutlet="Footer"></ng-container>
  </div>

  <div class="footer" *ngIf="view !== 'details' && view !== 'details-large'">
    <ng-container *ngTemplateOutlet="Footer"></ng-container>
  </div>

  <ng-container *ngIf="file?.status !== 'loading'">
    <div
      class="action-panel"
      *ngIf="file.tagging_visible && !forceHideTagging"
      (click)="$event.stopPropagation()"
    >
      <div style="margin-bottom: 12px">
        <label>File name</label>
        <input
          nz-input
          placeholder="File name"
          [ngModel]="file.filename | filename"
          (ngModelChange)="file.filename = $event; file.pending = true"
        />
      </div>
      <div style="display: inline-flex; width: 100%; gap: 12px">
        <div style="width: 50%">
          <label>Tags</label>
          <nz-select
            nzMode="tags"
            nzPlaceHolder="Select tags"
            [(ngModel)]="file.tag"
            (ngModelChange)="file.pending = true"
            style="width: 100%"
          >
            <nz-option
              *ngFor="let option of fileManagerService.tags$ | async"
              [nzLabel]="option.label"
              [nzValue]="option.value"
            ></nz-option>
          </nz-select>
        </div>
        <div style="width: 50%">
          <label>Category</label>
          <nz-select
            nzPlaceHolder="Select category"
            [(ngModel)]="file.category"
            (ngModelChange)="file.pending = true"
            style="width: 100%"
          >
            <nz-option
              *ngFor="let option of fileManagerService.categories$ | async"
              [nzLabel]="option.label"
              [nzValue]="option.value"
              [nzDisabled]="!option.status"
              nzCustomContent
            >
              <div style="display: inline-flex; gap: 8px; align-items: center">
                <div
                  [style.background]="option.color"
                  style="width: 12px; height: 12px; border-radius: 2px"
                ></div>
                {{ option.label }}
              </div>
            </nz-option>
          </nz-select>
        </div>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #Tooltip>
  <div *ngIf="file.filename">Filename: {{ file.filename | filename }}</div>
  <div *ngIf="file.extension">Extension: {{ file.extension }}</div>
  <div *ngIf="file.size">Size: {{ file.size | bytesToSize }}</div>

  <ng-container *ngIf="mode === 'private'">
    <div *ngIf="file.tag">Tag: {{ file.tag }}</div>
    <div *ngIf="file.category">Category: {{ file.category }}</div>
    <div *ngIf="file.user">Created by: {{ file.user.id | username }}</div>
    <div *ngIf="file.upload_date">
      Created at: {{ file.upload_date | moment: 'MMM DD, YYYY, HH:mm:ss' }}
    </div>
  </ng-container>
</ng-template>

<ng-template #Footer>
  <div style="overflow: hidden; width: 100%">
    <h3>
      <span>{{ file.filename | filename }}</span>
    </h3>
    <div class="details">
      <ng-container *ngIf="file.category && mode === 'private'">
        <app-avatar
          [user_id]="file.user.id"
          *ngIf="file.user?.id && showAvatar"
          [size]="18"
        ></app-avatar>

        <span
          [style.color]="file.category | fileCategoryColor"
          [innerHTML]="file.category | safe: 'html'"
        ></span>
        •
        <ng-container *ngIf="showSource">
          <span>
            {{ UploadSourcesNamming[file.source_name] }}
            {{ file.source_id }}
          </span>
          •
        </ng-container>
      </ng-container>

      <ng-container *ngIf="file.extension">
        {{ file.extension }}
        <ng-container *ngIf="file.size"> • </ng-container>
      </ng-container>

      <ng-container *ngIf="file.size">{{
        file.size | bytesToSize
      }}</ng-container>
    </div>
  </div>

  <div
    class="actions"
    *ngIf="showActions && file?.status !== 'loading'"
    (click)="$event.stopPropagation()"
  >
    <label
      nz-checkbox
      nz-tooltip
      nzTooltipTitle="Select"
      [(ngModel)]="file.checked"
      *ngIf="actions?.checkbox?.allow"
    ></label>

    <button
      nz-button
      nzType="default"
      nzShape="circle"
      nzSize="small"
      *ngIf="actions.tagging.allow"
      nz-tooltip
      [nzTooltipTitle]="file.tagging_visible ? 'Collapse' : 'Expand'"
      (click)="toggleTagging()"
    >
      <nz-icon
        [nzType]="file.tagging_visible ? 'caret-right' : 'caret-down'"
        nzTheme="outline"
      />
    </button>

    <button
      nz-button
      [nzDanger]="!previewMode"
      nzSize="small"
      [nzType]="previewMode ? 'default' : 'primary'"
      nzShape="circle"
      nz-popconfirm
      nz-tooltip
      [nzTooltipTitle]="previewMode ? 'Remove' : 'Delete'"
      [nzPopconfirmTitle]="
        previewMode ? 'Remove this file?' : 'Delete this file?'
      "
      (nzOnConfirm)="onRemove.emit(file)"
      *ngIf="actions.remove.allow"
    >
      <nz-icon [nzType]="!previewMode ? 'delete' : 'minus'" nzTheme="outline" />
    </button>

    <button
      nz-button
      nzSize="small"
      nzType="primary"
      nzShape="circle"
      nz-tooltip
      nzTooltipTitle="Update"
      (click)="onUpdate.emit(file)"
      *ngIf="actions.update?.allow && file.pending"
    >
      <nz-icon nzType="sync" nzTheme="outline" />
    </button>

    <nz-icon
      nzType="exclamation-circle"
      nzTheme="fill"
      nz-tooltip
      [nzTooltipTitle]="file.message"
      *ngIf="file.status === 'error'"
      style="color: #ff4d4f; font-size: 24px"
    />

    <nz-icon
      nzType="question-circle"
      nzTheme="outline"
      nz-tooltip
      [nzTooltipTitle]="'Pending upload / update'"
      *ngIf="file.pending"
      style="color: #ffa501; font-size: 24px"
    />
  </div>
</ng-template>
